/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { useMediaQuery } from '@mui/material';
import classnames from 'classnames';
import { PROMETHEAN_BREAKPOINT_SM } from '../styles/breakpoints/breakpoints';
import React from 'react';
import { useIntl } from 'react-intl';
import { EmbersButton } from '../button/button';
import { useRtl } from '../rtlProvider';
import { EmbersTypography } from '../typography';
export var ErrorContentTemplate = function ErrorContentTemplate(props) {
  var error = props.error,
    errorMessage = props.errorMessage,
    errorImage = props.errorImage,
    errorButton = props.errorButton,
    onBack = props.onBack;
  var _useRtl = useRtl(),
    transformRTL = _useRtl.transformRTL;
  var intl = useIntl();
  var mobile = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_SM, "px)"));
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('errorTemplate-root', {
      'errorTemplate-mobile': mobile
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "errorTemplate-image"
  }, typeof errorImage === 'string' ? /*#__PURE__*/React.createElement("img", {
    src: errorImage,
    alt: ""
  }) : errorImage), /*#__PURE__*/React.createElement(EmbersTypography, {
    variant: "h2",
    componentType: "h1",
    className: "errorTemplate-header"
  }, error), /*#__PURE__*/React.createElement("div", {
    className: "errorTemplate-body"
  }, errorMessage), onBack ? /*#__PURE__*/React.createElement(EmbersButton, {
    onClick: onBack,
    startIcon: /*#__PURE__*/React.createElement("span", {
      className: transformRTL('icon-arrow-left', 'icon-arrow-right')
    })
  }, intl.formatMessage({
    id: 'embers.button.back',
    defaultMessage: 'Back'
  })) : errorButton);
};